<template>
  <div class="modul">
    <div class="modul-top">
      <div class="caidan-img">
        <img src="../../../assets/image/caidan.png"
             alt="菜单">
      </div>
      <div class="caidan-title">
        个人中心
      </div>
    </div>
    <div class="modul-content">
      <el-tabs tab-position="left"
               v-model="editableTabsValue"
               style="height: 650px;position: relative;">
        <el-tab-pane label="个人信息"
                     name="1">
          <el-form ref="refForm"
                   :model="ruleForm"
                   :rules="formRules"
                   class="demo-form-inline"
                   label-width="100px">
            <!-- 头像 -->
            <el-form-item label="头像"
                          prop="img">
              <el-upload class="avatar-uploader"
                         :action="api + '/file/upload'"
                         :show-file-list="false"
                         :on-success="handleAvatarSuccess"
                         :before-upload="beforeAvatarUpload">
                <img v-if="ruleForm.img"
                     :src="ruleForm.img"
                     class="avatar">
                <i v-else
                   class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <!-- <img-upload ref="imgUpload"
                          :imageUrl="[ruleForm.img]"
                          :limit="limit"></img-upload> -->
            </el-form-item>
            <!-- 用户名称 -->
            <el-row>
              <el-col :span="8">
                <el-form-item label="用户名称"
                              prop="accountName">
                  <el-input v-model="ruleForm.accountName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="账号"
                              prop="accountNum">
                  <el-input v-model="ruleForm.accountNum"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="手机号码"
                              prop="phoneNum">
                  <el-input v-model="ruleForm.phoneNum"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="用户性别">
                  <el-select v-model="ruleForm.sex"
                             style="width: 100%;"
                             placeholder="请选择性别">
                    <el-option label="男"
                               :value='0'></el-option>
                    <el-option label="女"
                               :value='1'></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <!-- <el-col :span="8">
                <el-form-item label="角色"
                              prop="roleUuids">
                  <el-input v-model="ruleForm.roleUuids"
                            disabled></el-input>
                </el-form-item>
              </el-col> -->
              <!-- <el-col :span="8">
                <el-form-item label="区域"
                              prop="departmentUuid">
                  <el-input v-model="ruleForm.departmentUuid"
                            disabled></el-input>
                </el-form-item>
              </el-col> -->
            </el-row>
            <el-form-item>
              <div style="text-align:left;margin-top: 50px;">
                <el-button type="primary"
                           v-loading="loading"
                           @click="baoCun('refForm')">保存</el-button>
              </div>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="修改密码"
                     name="2">
          <el-form ref="ruleForm"
                   :model="form"
                   label-width="80px"
                   :rules="rules">
            <el-form-item label="旧密码"
                          style="width: 460px;"
                          prop="password">
              <el-input v-model="form.password"
                        placeholder="请输入旧密码"
                        show-password></el-input>
            </el-form-item>
            <el-form-item label="新密码"
                          style="width: 460px;"
                          prop="newPassword">
              <el-input v-model="form.newPassword"
                        placeholder="请输入新密码"
                        show-password></el-input>
            </el-form-item>
            <el-form-item>
              <div style="text-align:left;margin-top: 50px;">
                <el-button type="primary"
                           v-loading="loading"
                           @click="submitForm('ruleForm')">保存</el-button>
              </div>
            </el-form-item>
          </el-form>
          <!-- <el-form ref="ruleForm"
                   :model="form"
                   label-width="80px"
                   :rules="rules">
            <el-form-item label="旧密码"
                          style="width: 460px;"
                          prop="oldPassword">
              <el-input v-model="form.oldPassword"
                        placeholder="请输入旧密码"
                        clearable
                        show-password></el-input>
            </el-form-item>
            <el-form-item label="新密码"
                          style="width: 460px;"
                          prop="newPassword">
              <el-input v-model="form.newPassword"
                        clearable
                        placeholder="请输入新密码"
                        show-password></el-input>
            </el-form-item>
            <el-form-item label="确认密码"
                          style="width: 460px;"
                          prop="checkPass">
              <el-input type="password"
                        v-model="form.checkPass"
                        clearable
                        placeholder="请确认密码"
                        show-password></el-input>
            </el-form-item>
            <el-form-item>
              <div style="text-align:left;margin-top: 50px;">
                <el-button type="primary"
                           @click="onSubmit('ruleForm')">保存</el-button>
              </div>
            </el-form-item>
          </el-form> -->
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import md5 from 'js-md5';
import imgUpload from '../../components/upLoad/imgUpload.vue';
export default {
  name: 'ZuijiBridegUsercenter',
  components: {
    imgUpload
  },
  data () {
    // var validatePass = (rule, value, callback) => {
    //   if (typeof value == 'undefined' || value === '') {
    //     callback(new Error('请输入密码'));
    //   } else if (value !== this.oldPass) {
    //     callback(new Error('请输入正确的原密码'));
    //   }
    // };
    // var validatePass1 = (rule, value, callback) => {
    //   if (typeof value == 'undefined' || value === '') {
    //     callback(new Error('请输入新密码'));
    //   } else {
    //     if (value === this.form.oldPassword) {
    //       callback(new Error('与旧密码相同'));
    //     }
    //     callback();
    //   }
    // };
    // var validatePass2 = (rule, value, callback) => {
    //   if (typeof value == 'undefined' || value === '') {
    //     callback(new Error('请再次输入密码'));
    //   } else if (value !== this.form.newPassword) {
    //     callback(new Error('两次输入密码不一致!'));
    //   } else {
    //     callback();
    //   }
    // };
    return {
      limit: 1,
      editableTabsValue: '1',
      // 1
      loading: false,
      ruleFormImg: [],
      roleList: [],//角色列表
      ruleForm: {
        img: []
      },
      formRules: {
        accountName: [
          { required: true, message: "请输入用户名称", trigger: "blur" },
        ],
        // accountNum: [
        //   { required: true, message: "请输入账号", trigger: "blur" },
        // ],
        // password: [
        //   { required: true, message: "请输入密码", trigger: "blur" },
        // ],
        // departmentUuid: [
        //   { required: true, message: "请选择部门", trigger: "change" },
        // ],
        // roleUuids: [
        //   { required: true, message: "请选择角色", trigger: "change" },
        // ],
      },
      // 2
      // oldPass: '123456',
      loading1: false,
      form: {
        password: '',
        newPassword: '',
      },
      rules: {
        password: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
        ],
        // oldPassword: [
        //   // message: '请输入旧密码',
        //   { required: true, validator: validatePass, trigger: 'blur' },
        // ],
        // newPassword: [
        //   { required: true, validator: validatePass1, trigger: 'blur' },
        // ],
        // checkPass: [
        //   { required: true, validator: validatePass2, trigger: 'blur' },
        // ],
      },
      userintfo: {},
      // path: this.$route.path
    };
  },
  watch: {
    path (one, two) {
      this.editableTabsValue = '1'
      // console.log(one, two);
      this.initReq();
    }
  },
  computed: {
    path () {
      return this.$route.path
    },
    api () {
      return this.$config.host
    },
  },
  async mounted () {
    this.initReq();
    // this.ruleForm = JSON.parse(JSON.stringify(this.$store.state.userintfo))
    this.userintfo = JSON.parse(JSON.stringify(this.$store.state.userintfo))
    console.log(this.userintfo);
  },
  methods: {
    async initReq () {
      // console.log('表格参数', data);
      const res = await this.$api.sendPost("/accountInfo/getAllAccountInfo", { accountName: this.$store.state.userintfo.accountName, accountNum: this.$store.state.userintfo.accountNum });
      if (res.errcode === 0) {
        // console.log(res.data);
        this.ruleForm = res.data.voList[0]
      }
    },
    // one
    handleAvatarSuccess (res, file) {
      console.log(file);
      // this.ruleForm.img = URL.createObjectURL(file.raw);
      this.ruleForm.img = file.response.data.urlPath;
    },
    beforeAvatarUpload (file) {
      console.log(file);
      const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isPNG) {
        this.$message.error('上传头像图片只能是 PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isPNG && isLt2M;
    },
    baoCun (refForm) {
      this.$refs[refForm].validate(async (valid) => {
        if (valid) {
          this.loading = true
          // let data = {
          //   ...this.ruleForm,
          // }
		  let data = {
		  			accountNum:this.ruleForm.accountNum,
		    id:this.ruleForm.id,
		  			accountName:this.ruleForm.accountName,
		  			modifyTime:this.ruleForm.modifyTime,
		  			sex:this.ruleForm.sex,
		  }
          console.log(data);
          const res = await this.$api.sendPost('/accountInfo/insertOrUpdateAccountInfo', data);
          if (res.errcode === 0) {
            console.log(res);
            this.loading = false;
            this.$message.success(res.errmsg);
          } else {
            this.$message.warning(res.errmsg);
            this.loading = false;
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // two
    submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading1 = true
          let data = {
            password: md5.hex(this.form.password),
            // password: this.form.password,
            newPassword: md5.hex(this.form.newPassword),
            // newPassword: this.form.newPassword,
            id: this.userintfo.id,
            accountNum: this.userintfo.accountNum,
          }
          console.log(data);

          const res = await this.$api.sendPost('/accountInfo/updateAccountNumOrPassword', data);
          if (res.errcode === 0) {
            this.loading1 = false;
            this.$message.success({
              message: res.errmsg,
              duration: 1000,
              onClose: this.closeMs
            });
          } else {
            this.$message.warning(res.errmsg);
            this.loading1 = false;
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeMs () {
      this.$router.push("/login");
    }
    // 
    // getRoleList () {
    //   this.sendPost('/role/list').then(res => {
    //     if (res.errcode == 0) {
    //       this.roleList = res.data.voList;
    //       this.roleList.forEach((item) => {
    //         if (item.childRole == null || item.childRole.length == 0) {
    //           item.leaf = true;
    //         } else {
    //           item.leaf = false;
    //           item.childRole.forEach((ele) => {
    //             delete ele.childRole
    //             ele.leaf = true;
    //           });
    //         }
    //       });
    //     } else {
    //       this.err({ message: res.errmsg });
    //     }
    //     this.loading = false;
    //   })
    // },
  },
};
</script>

<style lang="scss" scoped>
.modul-search {
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .modul-btn {
    margin-left: 50px;
  }
}
.zhuangtai {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 60px;
  margin: 0 auto;
  .dian {
    width: 6px;
    height: 6px;
    border: 2px solid;
    border-radius: 50%;
  }
}
/deep/.el-dialog {
  height: 800px;
}
.avatar-uploader {
  text-align: left;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>